var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternationalTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 9.40204 9.40202 0 21 0C32.598 0 42 9.40204 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z",
    fill: "#DF9F39"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 13.5C19.5166 13.5 18.0666 13.9399 16.8332 14.764C15.5999 15.5881 14.6386 16.7594 14.0709 18.1299C13.5032 19.5003 13.3547 21.0083 13.6441 22.4632C13.9335 23.918 14.6478 25.2544 15.6967 26.3033C16.7456 27.3522 18.082 28.0665 19.5368 28.3559C20.9917 28.6453 22.4997 28.4968 23.8701 27.9291C25.2406 27.3614 26.4119 26.4001 27.236 25.1668C28.0601 23.9334 28.5 22.4834 28.5 21C28.5 20.0151 28.306 19.0398 27.9291 18.1299C27.5522 17.2199 26.9997 16.3931 26.3033 15.6967C25.6069 15.0003 24.7801 14.4478 23.8701 14.0709C22.9602 13.694 21.9849 13.5 21 13.5ZM20.25 26.9475C18.801 26.7649 17.4683 26.0601 16.5018 24.9652C15.5353 23.8703 15.0013 22.4605 15 21C15.0025 20.548 15.0553 20.0978 15.1575 19.6575L18.75 23.25V24C18.75 24.1989 18.829 24.3897 18.9697 24.5303C19.1103 24.671 19.3011 24.75 19.5 24.75H20.25V26.9475ZM26.04 24.24C25.9709 24.1655 25.8875 24.1058 25.7946 24.0646C25.7018 24.0233 25.6016 24.0014 25.5 24H23.25V21.75C23.25 21.5511 23.171 21.3603 23.0303 21.2197C22.8897 21.079 22.6989 21 22.5 21H18.75V19.5H20.25C20.4489 19.5 20.6397 19.421 20.7803 19.2803C20.921 19.1397 21 18.9489 21 18.75V17.25H23.25V15.4425C24.3572 15.8904 25.3056 16.6585 25.9736 17.6486C26.6417 18.6387 26.9991 19.8056 27 21C27.0009 22.1502 26.6673 23.2759 26.04 24.24Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_36"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternationalTransactions);
export default __webpack_public_path__ + "static/media/international_transactions.3cfeef3b74cc4378a0d75f8641395d0b.svg";
export { ForwardRef as ReactComponent };